import { TypographyV2 } from '@which/seatbelt'
import { ChevronRightIcon, CrossIcon } from '@which/seatbelt/src/components/Icons'
import { dynamicGa4DataLayerPush } from '@which/shared'

import { useLaptopHelperItemSpec } from '../hooks/useLaptopHelperItemSpec'
import styles from './LaptopHelperButton.module.scss'

interface LaptopHelperButtonProps {
  onClick: () => void
  onDismiss: () => void
}

export const LaptopHelperButton = ({ onClick, onDismiss }: LaptopHelperButtonProps) => {
  const buttonText = 'Need help finding your Laptop?'
  const itemSpec = useLaptopHelperItemSpec()

  const handleClick = () => {
    dynamicGa4DataLayerPush({
      event: 'personalisation_tool_action',
      action_group: 'action',
      item_text: buttonText,
      item_spec: itemSpec,
      item_group: 'personalisation tools',
      tool_name: 'Laptop picker helper',
      item_personalisation: 'false',
    })
    onClick()
  }

  return (
    <div className={styles.laptopHelperButton}>
      <button
        className={styles.launchButton}
        onClick={handleClick}
        type="button"
        aria-label={buttonText}
      >
        <div className={styles.desktopArtwork} aria-hidden="true" />
        <div className={styles.desktopCopy}>
          <TypographyV2 textStyle="sb-text-interface-body-default-strong">
            Choose your laptop with confidence
          </TypographyV2>
          <TypographyV2 textStyle="sb-text-interface-body-small-regular">
            Answer some questions about what you want, and we&apos;ll shortlist the best matches
            from hundreds of lab tested laptops
          </TypographyV2>
        </div>
        <span className={styles.laptopHelperButtonText}>{buttonText}</span>
        <ChevronRightIcon className={styles.chevronIcon} />
      </button>
      <button
        className={styles.closeButton}
        type="button"
        aria-label="Dismiss laptop helper launcher"
        onClick={onDismiss}
      >
        <CrossIcon width={15} height={15} customColour="gray" />
      </button>
    </div>
  )
}
